import { makeDataState, makePaginationState, STATUSES } from 'app/utils/redux';
import { EPISODE_STATUSES } from 'app/utils/constants';

import * as t from './types';

const initialState = {
  story: makeDataState(),
  episodes: makePaginationState(),
  readerInfo: makeDataState(),
  voucher: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch story
    case `${t.FETCH_MY_STORY}_PENDING`:
      return {
        ...state,
        story: {
          ...state.story,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_STORY}_SUCCESS`:
      return {
        ...state,
        story: {
          ...state.story,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_MY_STORY}_ERROR`:
      return {
        ...state,
        story: {
          ...state.story,
          status: STATUSES.ERROR,
        },
      };

    case `${t.UPDATE_MY_STORY}`:
      return {
        ...state,
        story: {
          ...state.story,
          data: {
            ...state.story.data,
            ...action.meta.story,
          },
        },
      };

    // fetch episodes
    case `${t.FETCH_MY_STORY_EPISODES}_PENDING`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_STORY_EPISODES}_SUCCESS`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.episodes.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_MY_STORY_EPISODES}_ERROR`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.ERROR,
        },
      };

    // remove episode
    case `${t.REMOVE_MY_EPISODE}_SUCCESS`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.episodes.pagination,
            items: state.episodes.pagination.items.filter(
              (episode) => episode.id !== action.meta.episodeId
            ),
          },
        },
      };
    case `${t.REMOVE_MY_EPISODE}_ERROR`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.ERROR,
        },
      };

    // patch episode
    case `${t.PATCH_MY_EPISODE}_SUCCESS`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.episodes.pagination,
            items: state.episodes.pagination.items.map((episode) => {
              if (episode.id === action.meta.episodeId) {
                return {
                  ...episode,
                  title: action.payload.result.title,
                  status: action.payload.result.status,
                };
              }

              return episode;
            }),
          },
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        episodes: makePaginationState(),
        readerInfo: makeDataState(),
      };

    case `${t.FETCH_READER_INFO}_SUCCESS`:
      return {
        ...state,
        readerInfo: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    case `${t.CANCEL_BOOKED}_SUCCESS`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.episodes.pagination,
            items: state.episodes.pagination.items.map((episode) => {
              if (episode.id === action.meta.episodeId) {
                return {
                  ...episode,
                  status: EPISODE_STATUSES.PRIVATE.type,
                  published: null,
                };
              }

              return episode;
            }),
          },
        },
      };

    case `${t.POST_EPISODE_STATISTIC}_SUCCESS`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.episodes.pagination,
            items: state.episodes.pagination.items.map((episode) => {
              if (episode.id === action.meta.episodeId) {
                return {
                  ...episode,
                  hasStatistic: true,
                };
              }

              return episode;
            }),
          },
        },
      };

    case `${t.FETCH_EPISODE_STATISTIC_VOUCHER_RECOMMENDATION}_SUCCESS`:
      return {
        ...state,
        voucher: {
          ...state.vouchers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    default:
      return { ...state };
  }
};
export { initialState };



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyDetail/reducer.js